export enum ProductStatus {
    GENERATED = 'GENERATED',
    ISSUED = 'ISSUED',
    APPLIED = 'APPLIED',
    INTRODUCED = 'INTRODUCED',
    SOLD = 'SOLD',
    DROPOUT = 'DROPOUT',
    AGGREGATED = 'AGGREGATED',
    DISAGGREGATED = 'DISAGGREGATED',
    ANNULLED = 'ANNULLED',
}

export enum ProductOperation {
    ANNULLED = 'ANNULLED',
    UNBLOCKED = 'UNBLOCKED',
    RETURNED_BY_CONSUMER = 'RETURNED_BY_CONSUMER',
    SOLD_TO_NON_PARTICIPANT = 'SOLD_TO_NON_PARTICIPANT',
    REJECTED_BY_BUYER = 'REJECTED_BY_BUYER',
    BLOCKED = 'BLOCKED',
    TRANSFERRED_BY_TRANSFER_DOCUMENT = 'TRANSFERRED_BY_TRANSFER_DOCUMENT',
    GENERATED = 'GENERATED',
    ISSUED = 'ISSUED',
    APPLIED = 'APPLIED',
    INTRODUCED = 'INTRODUCED',
    SOLD = 'SOLD',
    DROPOUT = 'DROPOUT',
    AGGREGATED = 'AGGREGATED',
    DISAGGREGATED = 'DISAGGREGATED',
    RETURNED = 'RETURNED',
    UTILISATION = 'UTILISATION',
    SALE_BY_INVOICE = 'SALE_BY_INVOICE',
    RECEIVED_BY_INVOICE = 'RECEIVED_BY_INVOICE',
    SALE_BY_TRANSFER_DOCUMENT = 'SALE_BY_TRANSFER_DOCUMENT',
    RECEIVED_BY_TRANSFER_DOCUMENT = 'RECEIVED_BY_TRANSFER_DOCUMENT',
    MOVED_BY_INVOICE = 'MOVED_BY_INVOICE',
    IMPORTED = 'IMPORTED',
    DEPARENTED = 'DEPARENTED',
    PARENTED = 'PARENTED',
    REPLACED_BY_REMARKING = 'REPLACED_BY_REMARKING',
    CREATED_BY_REMARKING = 'CREATED_BY_REMARKING',
}

export enum ProductsPackageType {
    BOX = 'BOX',
    BLOCK = 'BLOCK',
    PALLET = 'PALLET',
}

export enum OrderStatus {
    APPROVED = 'APPROVED',
    READY = 'READY',
    DECLINED = 'DECLINED',
    CLOSED = 'CLOSED',
}

export enum OrderTypes {
    LOCAL = 'LOCAL',
    IMPORT = 'IMPORT',
}

export enum DocumentStatus {
    REVIEW = 'REVIEW',
    REJECTED_AUTOMATIC = 'REJECTED_AUTOMATIC',
    CONFIRMED = 'CONFIRMED',
    PROCESSING = 'PROCESSING',
    CREATED = 'CREATED',
    DECLINED = 'DECLINED',
    APPROVED = 'APPROVED',
    PROCESSED = 'PROCESSED',
    DRAFT = 'DRAFT',

    IN_PROGRESS = 'IN_PROGRESS',
    UNDER_APPROVAL = 'UNDER_APPROVAL',
    RETURNED = 'RETURNED',
    APPROVED_FOR_SHIPMENT = 'APPROVED_FOR_SHIPMENT',
    PENDING = 'PENDING',
    SUBMITTED = 'SUBMITTED',
    CHECK_SUCCESS = 'CHECK_SUCCESS',
    CHECK_FAIL = 'CHECK_FAIL',
    ACCEPTED = 'ACCEPTED',
    REJECTED = 'REJECTED',
    NEW = 'NEW',
    COMPLETED = 'COMPLETED',
}

export enum DocumentReportType {
    AGGREGATE = 'AGGREGATE',
    DROPOUT = 'DROPOUT',
    INTRODUCE = 'INTRODUCE',
    UTILISATION = 'UTILISATION',
    UPD = 'UPD',
    MOVING = 'MOVING',
    RETURN_GOODS = 'RETURN_GOODS',
    REMARKING = 'REMARKING',
    TRANSFER_DOCUMENT = 'TRANSFER_DOCUMENT',
}

export enum DocumentReturnType {
    RETAIL_RETURN = 'RETAIL_RETURN',
    BUSINESS_RETURN = 'BUSINESS_RETURN',
}

export enum DocumentReturnSource {
    FORM = 'USER_FORM',
    OFD = 'OFD_POS_INTEGRATION',
    API = 'API_INTEGRATION',
}

export enum CheckStatus {
    UNDER_APPROVAL = 'UNDER_APPROVAL',
    RETURNED = 'RETURNED',
    APPROVED_FOR_SHIPMENT = 'APPROVED_FOR_SHIPMENT',
    PENDING = 'PENDING',
    CHECK_SUCCESS = 'CHECK_SUCCESS',
    CHECK_FAIL = 'CHECK_FAIL',
    ACCEPTED = 'ACCEPTED',
    REJECTED = 'REJECTED',

    NEW = 'NEW',
    CLOSED = 'CLOSED',
    DECLINED = 'DECLINED',
    APPROVED = 'APPROVED',
    CREATED = 'CREATED',
    PROCESSED = 'PROCESSED',
}

export enum GdsStatus {
    DRAFT = 'DRAFT',
    SUBMITTED = 'SUBMITTED',
    REVIEW = 'REVIEW',
    CONFIRMED = 'CONFIRMED',
    REJECTED = 'REJECTED',
    REJECTED_AUTOMATIC = 'REJECTED_AUTOMATIC',
}

export enum ReceiptType {
    INCOME = 'INCOME',
    RETURN = 'RETURN',
}

export enum ReceiptStatus {
    DECLINED = 'DECLINED',
    APPROVED = 'APPROVED',
    CREATED = 'CREATED',
    PROCESSED = 'PROCESSED',
}

export enum AuthenticStatus {
    'AUTHENTIC' = 'AUTHENTIC',
    'COUNTERFEIT' = 'COUNTERFEIT',
    // 'DUBIOUS' = 'DUBIOUS',
}

export enum AuthenticDetectionContext {
    RETAIL_SALES = 'RETAIL_SALES',
    MANUAL = 'MANUAL',
}
